import React from "react";
import { useLocation } from "react-router-dom";

import Toast from "../../../utils/Toast/Toast";
import ConfirmationModal from "../../../utils/ConfirmationModal/ConfirmationModal";

import StockFormFields from "./StockFormFields";
import { useAuth } from "../../../context/AuthContext";
import { useStockForm } from "../../../hooks/Edit/useStockForm";
import {
  handleUpdateStock,
  handleDeleteStock,
} from "./EditStockActions";

import "../styles/editStock.css";
import { useNavigate } from "react-router-dom";
import Loader from './../../../utils/Loader/Loader';

const EditStockForm = () => {
  const location = useLocation();
  const passedTx = location.state?.tx;
  const {userId} = useAuth();
const navigate = useNavigate();
  const {
    form,
    setForm,
    updateField,
    resetForm,
    isEditing,
    setIsEditing,
  } = useStockForm();
const [isUpdating, setIsUpdating] = React.useState(false);
  // 🔔 Toast state
  const [show, setShow] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [type, setType] = React.useState("success");

  const [showModal, setShowModal] = React.useState(false);
  const [isDeleting, setIsDeleting] = React.useState(false);

  // 🔔 Toast helper
  const showToast = (msg, toastType = "success") => {
    setMessage(msg);
    setType(toastType);
    setShow(true);

    setTimeout(() => {
      setShow(false);
    }, 3000);
  };

  // ✅ AUTO-FILL FORM FROM PASSED DATA
  React.useEffect(() => {
    if (passedTx) {
      setForm(passedTx);
      setIsEditing(true);
    } else {
      showToast("No transaction selected", "error");
    }
  }, [passedTx, setForm, setIsEditing]);

  // 🗑 Confirm delete
  const confirmDelete = async () => {
  try {
    setIsDeleting(true);

    await handleDeleteStock({
      form,
      resetForm,
      showToast,
      userId
    });

    setShowModal(false);

    showToast("Deleted successfully", "success");

    // ✅ NAVIGATE TO HOME
    navigate("/");

  } catch (err) {
    console.error(err);
    showToast("Delete failed", "error");

  } finally {
    setIsDeleting(false);
  }
};

  return (
    <div className="edit-container">
{isUpdating && (
  <Loader text="Updating transaction..." />
)}
      {/* ❌ REMOVED FetchStockBar */}

      {/* ✏️ Edit Form */}
      {isEditing && (
        <form
          className="transaction-form"
          onSubmit={(e) =>
            handleUpdateStock({
              e,
              form,
              resetForm,
              showToast,
              navigate,
              setIsUpdating,
              userId
            })
          }
        >
          <StockFormFields form={form} updateField={updateField} />

          <div className="form-actions">
            <button
  type="submit"
  disabled={isUpdating}
>
  {isUpdating ? "Updating..." : "Update"}
</button>
            <button
              type="button"
              onClick={() => setShowModal(true)}
              className="delete-button"
            >
              Delete
            </button>
          </div>
        </form>
      )}

      {/* ⚠️ Confirmation Modal */}
      {showModal && (
        <ConfirmationModal
          message="Are you sure you want to delete this stock?"
          onConfirm={confirmDelete}
          onCancel={() => !isDeleting && setShowModal(false)}
          loading={isDeleting}
        />
      )}

      {/* 🔔 Toast */}
      <Toast message={message} type={type} show={show} />
    </div>
  );
};

export default EditStockForm;